import { type ChatContext } from './chat-context.models';

export function getChatContextArtifactIdentity(context: ChatContext): string {
  switch (context.$type) {
    case 'table':
      return `table:${context.tableName}`;
    case 'page':
      return `page:${context.pageName}`;
    case 'component':
      return `component:${JSON.stringify([context.pageName, context.componentId ?? ''])}`;
    case 'source_workflow':
      return `source_workflow:${JSON.stringify([context.pageName, context.componentId ?? ''])}`;
    case 'action_workflow':
      return `action_workflow:${JSON.stringify([context.pageName, context.componentId ?? '', context.actionPath])}`;
    case 'workflow':
      return `workflow:${context.workflowId ?? ''}`;
    case 'project':
      return 'project';
  }
}
